// Enhanced Fasttr integration with BrainyTots UX
document.addEventListener('DOMContentLoaded', function() {
  // Track Fasttr prediction events
  window.addEventListener('fasttr_prediction_received', function(event) {
    const riskScore = event.detail.risk_score;
    const predictionId = event.detail.prediction_id;

    // Send to GA4
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'fasttr_prediction',
        risk_score: riskScore,
        prediction_id: predictionId,
        risk_bucket: getRiskBucket(riskScore)
      });
    }

    // Update UI based on risk score
    updateCodVisibility(riskScore);
    showRiskBasedMessaging(riskScore);
  });

  function getRiskBucket(riskScore) {
    if (riskScore > 0.7) return 'high';
    if (riskScore > 0.4) return 'medium';
    return 'low';
  }

  function updateCodVisibility(riskScore) {
    const codOptions = document.querySelectorAll('[data-payment-method="cod"]');
    const prepaidOptions = document.querySelectorAll('[data-payment-method="prepaid"]');

    if (riskScore > 0.7) { // High risk
      // De-emphasize COD, highlight prepaid
      codOptions.forEach(el => {
        el.style.opacity = '0.6';
        el.style.position = 'relative';
      });

      prepaidOptions.forEach(el => {
        el.style.border = '2px solid #ffd700';
        el.style.boxShadow = '0 0 8px rgba(255, 215, 0, 0.3)';
      });

      // Show high-risk warning
      showRiskWarning('Consider prepaid payment for faster delivery and guaranteed order processing');
    } else if (riskScore > 0.4) { // Medium risk
      // Add subtle emphasis to prepaid
      prepaidOptions.forEach(el => {
        el.style.border = '1px solid #ffd700';
      });
    }
  }

  function showRiskBasedMessaging(riskScore) {
    let banner = document.querySelector('.bt-fasttr-banner');
    if (!banner) {
      // Create banner if it doesn't exist
      const bannerContainer = document.createElement('div');
      bannerContainer.className = 'bt-fasttr-banner-container';
      bannerContainer.innerHTML = '<div class="bt-fasttr-banner"></div>';

      // Insert before payment methods
      const paymentSection = document.querySelector('.payment-methods, [data-payment-methods]');
      if (paymentSection) {
        paymentSection.parentNode.insertBefore(bannerContainer, paymentSection);
      }
    }

    banner = document.querySelector('.bt-fasttr-banner');
    if (!banner) return;

    let message = '';
    let icon = '';
    let bgColor = '';

    if (riskScore > 0.7) {
      message = '💡 Pay online and save ₹35 + get faster delivery!';
      icon = '⚠️';
      bgColor = '#fff3cd';
    } else if (riskScore > 0.4) {
      message = '💰 Save ₹35 when you pay online. COD also available.';
      icon = '💰';
      bgColor = '#d1ecf1';
    } else {
      message = '🎉 COD available! Or save ₹35 with online payment.';
      icon = '🎉';
      bgColor = '#d4edda';
    }

    banner.innerHTML = `<span class="bt-banner-icon">${icon}</span> <span class="bt-banner-text">${message}</span>`;
    banner.style.cssText = `
      background: ${bgColor};
      border: 1px solid #dee2e6;
      border-radius: 8px;
      padding: 12px 16px;
      margin: 16px 0;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;
    `;

    banner.style.display = 'flex';

    // Track banner view
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'prepaid_discount_banner_view',
        risk_score: riskScore,
        banner_type: getRiskBucket(riskScore)
      });
    }
  }

  function showRiskWarning(message) {
    const warning = document.createElement('div');
    warning.className = 'bt-risk-warning';
    warning.innerHTML = `<span class="warning-icon">⚠️</span> <span class="warning-text">${message}</span>`;
    warning.style.cssText = `
      background: #fff3cd;
      border: 1px solid #ffeaa7;
      border-radius: 6px;
      padding: 10px 14px;
      margin: 10px 0;
      font-size: 13px;
      color: #856404;
      display: flex;
      align-items: center;
      gap: 8px;
    `;

    const paymentMethods = document.querySelector('.payment-methods, [data-payment-methods]');
    if (paymentMethods) {
      paymentMethods.insertBefore(warning, paymentMethods.firstChild);
    }
  }
});

// Track COD vs Prepaid selection
document.addEventListener('change', function(e) {
  if (e.target.matches('[data-payment-method], input[name="payment_method"], [name*="payment"]')) {
    const method = e.target.value || e.target.dataset.paymentMethod;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'payment_method_selected',
        payment_method: method,
        discount_applied: method && method.toLowerCase().includes('prepaid')
      });
    }
  }
});

// Track prepaid discount clicks
document.addEventListener('click', function(e) {
  if (e.target.closest('.bt-sticky-incentive, .bt-prepaid-incentive, .bt-fasttr-banner')) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'prepaid_discount_click',
        location: e.target.closest('.bt-sticky-atc-bar') ? 'sticky_bar' :
                  e.target.closest('.bt-fasttr-banner') ? 'cart_banner' :
                  'pdp_incentive'
      });
    }
  }
});

// Initialize Fasttr prediction listener
if (window.Fasttr) {
  // Listen for Fasttr prediction events
  document.addEventListener('fasttr:prediction', function(e) {
    const event = new CustomEvent('fasttr_prediction_received', {
      detail: {
        risk_score: e.detail.riskScore,
        prediction_id: e.detail.predictionId
      }
    });
    document.dispatchEvent(event);
  });
}
